import React from 'react';
import { ReportWorkspace } from './reporting/ReportWorkspace';
export default function ListaChamadaPage() { return <ReportWorkspace report="lista-chamada" />; }